import { createI18n } from 'vue-i18n';
import ru from '@/locales/ru.js';
import en from '@/locales/en.js';
import de from '@/locales/de.js';
import es from '@/locales/es.js';
import it from '@/locales/it.js';

function loadLocaleMessages() {
    const locales = [
        { en: en },
        { ru: ru },
        { de: de },
        { es: es },
        { it: it },
    ];
    const messages = {};
    locales.forEach((lang) => {
        const key = Object.keys(lang);
        messages[key] = lang[key];
    });
    return messages;
}

function getCurrentLang() {
    if (localStorage.getItem('lang') !== null) {
        return localStorage.getItem('lang');
    } else if (document.location.pathname.split('/')[1] !== null) {
        return document.location.pathname.split('/')[1];
    } else {
        return 'en';
    }
}

export default createI18n({
    locale: getCurrentLang(),
    fallbackLocale: 'ru',
    messages: loadLocaleMessages(),
});
